<template>
  <section class="hero is-fullheight payment-page">
    <PmNavbar />
    <div class="hero-body">
      <div class="container">
        <div class="columns is-multiline white-bg">
          <div class="column is-12">
            <div class="columns">
              <div class="column is-12">
                <h1 class="has-text-left is-ubuntu is-black font-30 mt-5">
                  {{ this.$t("message.pages.paymentPage.title") }}
                </h1>
                <p class="has-text-left is-ubuntu is-black font-12 mt-5">
                  {{ this.$t("message.pages.paymentPage.subtitle") }}
                </p>
              </div>
            </div>
          </div>

          <!-- Start Cart Line -->
          <div v-for="(product, index) in not_draft_products" :key="index" class="column is-12 px-5 gray-top-border">
            <div class="columns">
              <div class="column is-3 has-text-centered product-row">
                <figure class="image product-figure">
                  <img :src="getItemThumbnail(product)">
                </figure>
                <p class="is-ubuntu font-15 has-text-left" v-if="!product.material">{{ getProductName(product) }}</p>
                <p class="is-ubuntu font-15 has-text-left" v-else>{{ getProductName(product) }}, {{
                  getProductMaterialName(product.material) }}</p>
              </div>

              <div class="column is-2 is-flex is-align-items-center is-justify-content-flex-end">
                <div class="text-wrapper is-inline-block">
                  <p>x {{ product.amount }}</p>
                </div>
              </div>

              <div class="column is-2 is-offset-5 is-flex is-align-items-center is-justify-content-flex-end">
                <span class="font-18">{{ this.$t("message.pages.paymentPage.eachPrepText") }}
                  {{ getVolumeDiscountPerCupSize(product.product, product.material).toFixed(2) }} € </span>

              </div>

            </div>
          </div>

          <div v-for="(form, index) in non_draft_forms" :key="index" class="column is-12 px-5">
            <div class="columns">
              <div class="column is-3 has-text-centered product-row">
                <figure class="image">
                  <img :src="getItemThumbnail(form)">
                </figure>
                <p class="font-15">{{ getProductName(form.product) }}</p>
              </div>

              <div class="column is-2 is-flex is-align-items-center is-justify-content-flex-end">
                <div class="text-wrapper is-inline-block">
                  <p>x {{ form.amount }}</p>
                </div>
              </div>

              <div class="column is-2 is-offset-5 is-flex is-align-items-center is-justify-content-flex-end">
                <span class="font-18">{{ this.$t("message.pages.paymentPage.eachPrepText") }}
                  {{ getVolumeDiscountPerCupSize(form.product).toFixed(2) }} €</span>
              </div>
            </div>
          </div>

          <!-- End Cart Line -->

          <!-- Start amount by cup sizes -->
          <div class="column is-12 gray-top-border">
            <div class="columns">
              <div class="column has-text-right">
                <template v-for="(cup, idx) in this.$store.getters.getProducts" :key="idx">
                  <p class="font-15 is-ubuntu has-text-weight-bold"
                    v-if="this.$store.getters.getItemsTotalAmountByProduct(cup.id) > 0 && cup.resource_type != 'Plate' && cup.resource_type != 'StoreProduct' && cup.resource_type != 'Lid'">
                    {{ cup.name }}: {{ this.$store.getters.getItemsTotalAmountByProduct(cup.id) }} {{
                      this.$t("message.pages.cartPage.eachPieceText") }} {{
                      this.$t("message.pages.paymentPage.eachPrepText") }} {{ getVolumeDiscountPerCupSize(cup.id) }} € =
                    {{ (getVolumeDiscountPerCupSize(cup.id) *
                      this.$store.getters.getItemsTotalAmountByProduct(cup.id)).toFixed(2) }} €</p>
                </template>
                <template v-for="(plate, idx) in non_draft_plates_by_material" :key="idx">
                  <p class="font-15 is-ubuntu has-text-weight-bold">{{ getProductName(plate.product) }}: {{
                    this.$store.getters.getItemsTotalAmountByProduct(plate.product, plate.material) }} {{
                      this.$t("message.pages.cartPage.eachPieceText") }} {{ this.$t("message.pages.cartPage.costPrepText")
                    }} {{ getVolumeDiscountPerCupSize(plate.product, plate.material) }} € =
                    {{ (getVolumeDiscountPerCupSize(plate.product, plate.material) *
                      this.$store.getters.getItemsTotalAmountByProduct(plate.product, plate.material)).toFixed(2) }} €</p>
                </template>
              </div>
            </div>
          </div>
          <!-- End amount by cup sizes -->

          <!-- Start Shipping voucher -->
          <div class="column is-12" v-if="getShipping">
            <div class="columns">
              <div class="column has-text-right">
                <span class="font-15 is-ubuntu has-text-weight-bold">Toimituskulu</span>
                <span class="font-15 is-ubuntu has-text-weight-bold"> = {{ (getShipping.price / 100).toFixed(2) }}
                  €</span>
              </div>
            </div>
          </div>
          <!-- End Shipping voucher -->

          <!-- Start additional charge for under 150 € -->
          <div class="column is-12" v-if="additionalChargeCost != 0">
            <div class="columns">
              <div class="column has-text-right">
                <span class="font-15 is-ubuntu has-text-weight-bold">Pientoimituslisä</span>
                <span class="font-15 is-ubuntu has-text-weight-bold"> = {{ additionalChargeCost.toFixed(2) }} €</span>
              </div>
            </div>
          </div>
          <!-- End additional charge for under 150 € -->

          <!-- Start transport costs -->
          <div class="column is-12" v-if="transportCost != 0">
            <div class="columns">
              <div class="column has-text-right">
                <span class="font-15 is-ubuntu has-text-weight-bold">Toimituskulut</span>
                <span class="font-15 is-ubuntu has-text-weight-bold"> = {{ transportCost.toFixed(2) }} €</span>
              </div>
            </div>
          </div>
          <!-- End transport costs -->

          <!-- Start total amount -->
          <div class="column is-12">
            <div class="columns">
              <div class="column has-text-right">
                <p class="font-15 is-ubuntu has-text-weight-bold" v-if="non_draft_forms.length > 0">{{
                  this.$t("message.pages.paymentPage.suunniText") }} {{ non_draft_forms.length }} x
                  {{ this.$store.getters.getDesignServiceFee.price }} € = {{ getDesignServiceTotalFee }} €</p>

                <span class="font-15 is-ubuntu has-text-weight-bold">{{ this.$store.getters.getItemsTotalAmount }} {{
                  this.$t("message.pages.paymentPage.eachPieceText") }}</span>
                <span class="font-15 is-ubuntu has-text-weight-bold"> = {{ finalPriceNoVat }} €</span>
              </div>
            </div>
          </div>
          <!-- End total amount -->

          <div class="column is-12" v-if="this.voucherAmountOff != null">
            <div class="columns">
              <div class="column is-4 is-offset-8 has-text-right">
                <span class="font-15 has-text-weight-bold">
                  {{ this.voucherCode }} - {{ this.voucherAmountOff / 100 }} €
                </span>
              </div>
            </div>
          </div>

          <div class="column is-12" v-if="this.voucherPercentOff != null">
            <div class="columns">
              <div class="column is-4 is-offset-8 has-text-right">
                <span class="font-15 has-text-weight-bold">
                  {{ this.voucherCode }} - {{ this.voucherPercentOff }} %
                </span>
              </div>
            </div>
          </div>

          <!-- Start total amount with VAT-->
          <div class="column is-12" v-for="vat in vatBreakdown" :key="vat.rate">
            <div class="columns">
              <div class="column has-text-right">
                <span class="font-15 is-ubuntu has-text-weight-bold">ALV {{ vat.rate }}%</span>
                <span class="font-15 is-ubuntu has-text-weight-bold"> = {{ vat.withVat.toFixed(2) }} €</span>
              </div>
            </div>
          </div>
          <div class="column is-12" v-if="hasMultipleVatRates">
            <div class="columns">
              <div class="column has-text-right">
                <span class="font-15 is-ubuntu has-text-weight-bold">ALV {{ this.$t("message.pages.cartPage.totalText")
                  }}</span>
                <span class="font-15 is-ubuntu has-text-weight-bold"> = {{ finalPrice }} €</span>
              </div>
            </div>
          </div>
          <!-- End total amount with VAT-->

          <!-- Start voucher -->
          <div class="column is-12">
            <div class="columns">
              <div class="column is-4">
                <input class="input pm-input voucher-input" type="text"
                  :placeholder="$t('message.pages.paymentPage.voucherInputPlaceholder')" v-model="voucherCode" />
                <span class="control is-expanded is-small has-text-danger">
                  {{ voucherCodeError }}
                </span>
              </div>

              <div class="column is-3 is-flex is-align-items-center is-justify-content-center">
                <button class="pyroll-button-rectangle" @click="addVoucher">
                  {{ this.$t("message.pages.paymentPage.voucherButtonText") }}
                </button>
                <button class="pyroll-button-rectangle ml-5" @click="clearVoucher"
                  v-if="this.voucherId != null || this.voucherFixedPriceId != null">
                  {{ this.$t("message.pages.cartPage.clearVoucherButtonText") }}
                </button>
              </div>
            </div>
          </div>
          <!-- End voucher -->

          <!-- Start Contact data -->
          <div class="column is-12">
            <div class="columns">
              <div class="column mt-5">
                <h4 class="custom-black font-secondary mb-3" v-if="this.getContactData().bill_name != ''">
                  {{ this.$t("message.pages.paymentPage.contactHeadingTwo") }}
                </h4>
                <h4 class="custom-black font-secondary mb-3" v-else>
                  {{ this.$t("message.pages.paymentPage.contactHeadingOne") }}
                </h4>
                <p>{{ getContactData().recv_company }}</p>
                <p>{{ getContactData().recv_name }}</p>
                <p>{{ getContactData().recv_phone }}</p>
                <p>{{ getContactData().cust_email }}</p>
                <p>{{ getContactData().recv_street }}</p>
                <p>{{ getContactData().recv_zip }}</p>
                <p>{{ getContactData().recv_town }}</p>
                <h4 class="custom-black mt-5 mb-3 font-secondary" v-if="this.getContactData().bill_name != ''">
                  {{ this.$t("message.pages.paymentPage.contactHeadingOne") }}
                </h4>
                <p v-if="this.getContactData().cust_vat_nr != ''">
                  {{ getContactData().bill_company }}
                </p>
                <p v-if="this.getContactData().cust_vat_nr != ''">
                  {{ getContactData().bill_name }}
                </p>
                <p v-if="this.getContactData().cust_vat_nr != ''">
                  {{ getContactData().bill_phone }}
                </p>
                <p v-if="this.getContactData().cust_vat_nr != ''">
                  {{ getContactData().bill_street }}
                </p>
                <p v-if="this.getContactData().cust_vat_nr != ''">
                  {{ getContactData().bill_town }}
                </p>
              </div>
            </div>
          </div>
          <!-- End Contact data -->

          <div class="column is-12">
            <!-- <div class="columns" v-if="this.getContactData().b2b">
              <div class="column mt-5">
                {{ this.$t("message.pages.paymentPage.lahetammeText_1") }}
                <br>
                {{ this.$t("message.pages.paymentPage.lahetammeText_2") }}
              </div>
            </div> -->

            <div class="columns has-text-centered-mobile">
              <button class="pyroll-button-rectangle my-5 mr-3" @click="goBack()">
                {{ this.$t("message.pages.paymentPage.goBackButtonText") }}
              </button>
              <button class="pyroll-button green-bg my-5 ml-5-desktop" @click="payCreditCard">
                {{ this.$t("message.pages.paymentPage.maksamaanButtonText") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PmFooter />
  </section>
</template>

<script>
import PmFooter from "../components/PmFooter"
import PmNavbar from '../components/PmNavbar'
import { mapGetters, mapMutations, mapActions } from "vuex"
import cartMixin from "@/mixins/cartMixin"
import pricingMixin from "@/mixins/pricingMixin"

export default {
  name: "PaymentPage",
  components: {
    PmFooter,
    PmNavbar
  },
  mixins: [cartMixin, pricingMixin],
  data() {
    return {
      voucherCode: "",
      voucherCodeError: "",
      voucherId: null,
      voucherFixedPriceId: null,
      voucherIgnoreAdditional25Fee: false,
      voucherPercentOff: null,
      voucherAmountOff: null
    };
  },
  methods: {
    ...mapGetters({
      getContactData: "getContactData",
      getProducts: "getProducts",
      getProductById: "getProductById",
      getVoucher: "getVoucher",
      getFixedVoucher: "getFixedVoucher"
    }),
    ...mapMutations({
      setSpinnerState: "setSpinnerState",
      setFixedVoucher: "setFixedVoucher",
      setVoucher: "setVoucher"
    }),
    ...mapActions({
      partialUpdateOrder: "partialUpdateOrder",
      createPaytrailSession: 'createPaytrailSession'
    }),
    addVoucher() {
      this.voucherCodeError = "";
      if (this.voucherCode.length < 1) {
        this.voucherCodeError = "Lisää alennus koodi";
        return;
      }
      this.setSpinnerState(true);
      this.$store
        .dispatch("addVoucher", { code: this.voucherCode })
        .then((resp) => {
          if (resp.status === 404) {
            this.voucherCodeError = "Lisää oikea alennus koodi";
          } else {
            if (resp.data.amount_off != null) {
              this.voucherAmountOff = resp.data.amount_off
              this.voucherId = resp.data.id
              this.setVoucher({
                percent_off: resp.data.percent_off,
                amount_off: resp.data.amount_off,
                id: resp.data.id,
                code: this.voucherCode
              })
            } else if (resp.data.percent_off != null) {
              this.voucherPercentOff = resp.data.percent_off
              this.voucherId = resp.data.id
              this.setVoucher({
                percent_off: resp.data.percent_off,
                amount_off: resp.data.amount_off,
                id: resp.data.id,
                code: this.voucherCode
              })
            } else if (resp.data.price && resp.data.product) {
              this.setFixedVoucher({
                product: resp.data.product,
                price: (resp.data.price / 100).toFixed(2) * 1, // backend saves in cents
                ignore_additional_25_fee: resp.data.ignore_additional_25_fee,
                fixed_transport_cost: resp.data.fixed_transport_cost != null ? resp.data.fixed_transport_cost / 100 : null,
                id: resp.data.id,
                code: this.voucherCode
              })
              this.voucherFixedPriceId = resp.data.id
              this.voucherIgnoreAdditional25Fee = resp.data.ignore_additional_25_fee
            }
          }
        })
        .catch((err) => (this.voucherCodeError.value = err))
        .finally(() => {
          this.setSpinnerState(false);
        });
    },
    clearVoucher() {
      this.voucherCode = ""
      this.voucherCodeError = ""
      this.voucherId = null
      this.voucherFixedPriceId = null
      this.voucherIgnoreAdditional25Fee = false
      this.voucherPercentOff = null
      this.voucherAmountOff = null
      this.setFixedVoucher({})
      this.setVoucher({})
    },
    goBack() {
      this.$router.push({
        name: "Cart",
        params: {
          uuid: this.$route.params.uuid,
        },
      });
    },
    payCreditCard() {
      this.setSpinnerState(true)
      this.createPaytrailSession({ voucher: this.voucherCode })
        .then(() => {
          let checkout = this.$store.state.paytrailSessionData['response']
          window.location.replace(checkout)
        })
        .catch(function (error) {
          console.error('Error:', error)
        })
    }
  },
  mounted() {
    this.setSpinnerState(false);
    // init vouchers if there are any
    if (this.getVoucher() != {}) {
      this.voucherAmountOff = this.getVoucher().voucherAmountOff
      this.voucherId = this.getVoucher().id
      this.voucherCode = this.getVoucher().code
      this.voucherPercentOff = this.getVoucher().voucherPercentOff
    }
    if (this.getFixedVoucher != {}) {
      this.voucherFixedPriceId = this.getFixedVoucher().id
      this.voucherIgnoreAdditional25Fee = this.getFixedVoucher().ignore_additional_25_fee
      this.voucherCode = this.getFixedVoucher().code
    }
  }
};
</script>

<style scoped lang="scss">
@use '../assets/sass/variables' as *;

.payment-page {

  .container {
    padding-left: 12px;
    padding-right: 12px;
  }

  .custom-black {
    color: $font-color-primary;
  }

  .white-bg {
    background-color: #ffffff;
  }

  .amount-input {
    width: 66px;
    height: 31px;
    background-color: #dedbd9;
  }

  .gray-top-border {
    border-top: 2px solid #D0D3D4;
  }

  .visibility-hidden {
    visibility: hidden;
  }

  // Remove arrows in number input type
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  .svg-inline--fa {
    cursor: pointer;
  }

  .mandatory-fields-text {
    color: #dedbd9;
  }

  .buttons-wrapper {
    @media only screen and (max-width: 768px) {
      flex-direction: column;
      align-items: center;
    }
  }
}

.gray-top-border {
  border-top: 2px solid #D0D3D4;
}

.text-wrapper {
  text-overflow: ellipsis;
  overflow: hidden;
}

.voucher-input {
  height: 40px;
}

.product-row {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.product-figure {
  flex: 0 0 50%;
}

.product-figure img {
  width: 100%;
  height: auto;
}

.is-disabled {
  background-color: #b5b5b5;
  cursor: not-allowed;
}

@media (min-width: 1024px) {
  .ml-5-desktop {
    margin-left: 1.25rem !important;
  }
}
</style>
